import React from 'react';
import {ModelFormField} from "../../../../components/ModelFormHOC";
import {FazendaObject} from "../../../../models/Fazenda";

interface FormQuestionarioCorteProps {
  fazenda: FazendaObject;
}

const FormQuestionarioCorte: React.FC<FormQuestionarioCorteProps> = ({fazenda}) => {
  return (
    <>
      <div className="text-xl font-hairline mt-6">
        Fazendas de corte
      </div>
      <ModelFormField field="data_inicio_em"/>
      <ModelFormField field="femeas_submetidas_iatf"/>
      <ModelFormField field="bezerros_nascidos"/>
      <ModelFormField field="bezerros_desmamados"/>

      <div className="text-xl font-hairline mt-6">
        Rebanho de Corte
      </div>
      {
        fazenda.sistema_producao.indexOf('Cria') !== -1 &&
          <>
            <div className="ml-5 text-xl font-hairline mt-4">
              Cria
            </div>
            <ModelFormField field="corte_cria_vacas"/>
            <ModelFormField field="corte_cria_novilhas"/>
            <ModelFormField field="corte_cria_bezerros"/>
            <ModelFormField field="corte_cria_touros"/>
          </>
      }
      {
        fazenda.sistema_producao.indexOf('Recria') !== -1 &&
          <>
            <div className="ml-5 text-xl font-hairline mt-4">
              Recria
            </div>
            <ModelFormField field="corte_recria_novilhas"/>
            <ModelFormField field="corte_recria_garrotes"/>
          </>
      }
      {
        fazenda.sistema_producao.indexOf('Engorda') !== -1 &&
          <>
            <div className="ml-5 text-xl font-hairline mt-4">
              Engorda
            </div>
            <ModelFormField field="corte_engorda_bois"/>
            <ModelFormField field="corte_engorda_femeas"/>
          </>
      }
      {
        fazenda.sistema_producao.indexOf('Confinamento') !== -1 &&
          <>
            <div className="ml-5 text-xl font-hairline mt-4">
              Confinamento
            </div>
            <ModelFormField field="corte_confinamento_machos"/>
            <ModelFormField field="corte_confinamento_femeas"/>
          </>
      }
    </>
  );
}

export default FormQuestionarioCorte;
